import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import Inicio from './Inicio/Inicio';
import Vendas from './Vendas/Vendas';
import Receitas from './Receitas/Receitas';
import Despesas from './Despesas/Despesas';
import { cores } from '../../../styles/styleUtils';

const TabContainer = styled.div`
  display: flex;
  background-color: ${cores.cinzaClaro};
  border-bottom: 1px solid ${cores.cinzaClaro};
`;

const TabButton = styled.button`
  background: none;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 1rem;
  color: ${cores.cinzaMedio};
  border-bottom: 2px solid transparent;
  transition: border-bottom 0.3s ease;

  &:hover {
    color: ${cores.chumbo};
  }

  &.active {
    color: ${cores.laranja};
    border-bottom: 2px solid ${cores.laranja};
  }
`;

const TabContent = styled.div`
  padding: 20px;
`;

const DashboardPage = () => {
  const [activeTab, setActiveTab] = useState('home');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div>
      <Helmet>
        <title> Dashboard </title>
      </Helmet>
      <TabContainer>
        <TabButton className={activeTab === 'home' ? 'active' : ''} onClick={() => handleTabClick('home')}>
          Home
        </TabButton>
        <TabButton className={activeTab === 'vendas' ? 'active' : ''} onClick={() => handleTabClick('vendas')}>
          Vendas
        </TabButton>
        <TabButton className={activeTab === 'receitas' ? 'active' : ''} onClick={() => handleTabClick('receitas')}>
          Receitas
        </TabButton>
        <TabButton className={activeTab === 'despesas' ? 'active' : ''} onClick={() => handleTabClick('despesas')}>
          Despesas
        </TabButton>
      </TabContainer>

      <TabContent>
        {activeTab === 'home' && <Inicio />}
        {activeTab === 'vendas' && <Vendas />}
        {activeTab === 'receitas' && <Receitas />}
        {activeTab === 'despesas' && <Despesas />}
      </TabContent>
    </div>
  );
};

export default DashboardPage;